import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddToList from "../components/AddToList";
import { Card } from "react-bootstrap";
import "./style.css";
import BrandDisplay from "../NewsFeed/BrandDisplay";
import formatPrice from "../lib/formatPrice";
import AddToChat from "../components/AddToChat";
import AddToCart from "../components/AddToCart";
import AddOrRemoveLike from "./AddOrRemoveLike";

const Skeleton = ({ product }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ padding: isSmallScreen ? "6px 1.5px" : "8px 4px" }}>
      <div
        className="d-flex flex-column justify-content-between"
        style={{
          borderRadius: "6px",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#0000001A",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "280px",
          }}
        >
          <div
            className="skeleton"
            style={{ height: "100%", borderRadius: "2px 2px 0px 0px" }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "3px",
              right: "3px",
              zIndex: 10,
              width: "20px",
              height: "20px",
              backgroundColor: "#c3c3c3",
              borderRadius: "2px",
            }}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              className="skeleton"
              style={{ width: "20px", height: "20px" }}
            />
          </div>
        </div>
        <div
          className={`d-flex justify-content-between flex-column`}
          style={{
            gap: "6px",
            padding: "6px 3px 3px",
          }}
        >
          <div
            className="d-flex flex-column"
            style={{
              gap: "2px",
              width: "100%",
            }}
          >
            <div
              className="skeleton"
              style={{ width: "100%", height: "14px" }}
            />
            <div
              className="skeleton"
              style={{ width: "100%", height: "24px" }}
            />
          </div>
          <div className="d-flex w-100" style={{ gap: "2px" }}>
            <div
              className="skeleton"
              style={{
                width: "50%",
                height: "33px",
                borderRadius: "0 0 0 3px",
              }}
            />
            <div
              className="skeleton"
              style={{
                width: "50%",
                height: "33px",
                borderRadius: "0 0px 3px 0px",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
